import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleFieldCreateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchModuleFieldCreate = createAsyncThunk(
    'moduleFieldCreate/fetchModuleFieldCreate',
    async ({ file, moduleId, Name }) => {
        const response = await ModuleFieldCreateService(file, moduleId, Name)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
)

const moduleFieldCreateSlice = createSlice({
    name: 'moduleFieldCreate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleFieldCreate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleFieldCreate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleFieldCreate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleFieldCreateSlice.reducer;
